import { Component } from '../Component'
import { element } from '../CustomElement'
import { icons } from '../../icons/Icons'
import { i18n } from '../../i18n/I18n'
import { Link } from '../flipp-link/Link'
import { inject } from '../../services/di'
import { LocationService } from '../../services/LocationService'
import { EventService } from '../../services/EventService'

export const AD_BLOCKER_POPUP_TAG_ELEMENT_ID = 'ad-blocker-detected-popup'
export const NOT_SELL_DATA_POPUP_TAG_ELEMENT_ID =
    'not-sell-data-confirmation-popup'
export const DELETE_ACCOUNT_CONFIRMATION_POPUP_TAG_ELEMENT_ID =
    'delete-account-confirmation-popup'

const HIDE_POPUP_TIMEOUT = 10000

@element('flipp-info-popup')
export class InfoPopup extends Component<any, any> {
    @inject location: LocationService
    @inject eventService: EventService

    state: {
        visible: boolean
    } = {
        visible: false,
    }

    onAttach() {
        window.addEventListener(
            'display-info-popup',
            this.displayPopup.bind(this)
        )
    }

    render() {
        return (
            <template>
                {this.renderConfirmDeleteAccountPopup()}
                {this.renderConfirmNotSellDataPopup()}
                {this.renderAdBlockerDetectedPopup()}
            </template>
        )
    }

    displayPopup(e: any) {
        const id = e.detail.id
        if (!this.state.visible) {
            this.state.visible = true
            const popup = document.getElementById(id)
            if (popup) {
                popup.classList.add('visible')
                setTimeout(() => {
                    this.hidePopup(id)
                }, HIDE_POPUP_TIMEOUT)
            }
        } else {
            setTimeout(() => {
                this.state.visible = false
                this.displayPopup({ detail: { id } })
            }, HIDE_POPUP_TIMEOUT)
        }
    }

    hidePopup(id: string) {
        const popup = document.getElementById(id)
        if (popup) popup.classList.remove('visible')
    }

    renderConfirmDeleteAccountPopup() {
        return (
            <div
                id={DELETE_ACCOUNT_CONFIRMATION_POPUP_TAG_ELEMENT_ID}
                class="confirmation-wrapper"
            >
                <div class="confirmation" flex-horizontal>
                    <div>{icons.user}</div>
                    <div class="confirmation-message">
                        {i18n('delete_account_confirmation')}
                    </div>
                </div>
            </div>
        )
    }

    renderConfirmNotSellDataPopup() {
        return (
            <div
                id={NOT_SELL_DATA_POPUP_TAG_ELEMENT_ID}
                class={`confirmation-wrapper not-sell ${this.location.locale === 'fr-ca' ? 'fr' : ''} `}
            >
                <div class="confirmation" flex-horizontal>
                    <div class="confirmation-message-icon">{icons.user}</div>
                    <div class="confirmation-message">
                        {i18n('not_sell_data_confirmation')}
                    </div>
                </div>
                <button>
                    <Link href={'data'}>{i18n('manage')}</Link>
                </button>
            </div>
        )
    }

    renderAdBlockerDetectedPopup() {
        return (
            <div
                id={AD_BLOCKER_POPUP_TAG_ELEMENT_ID}
                class={`confirmation-wrapper ad-blocker ${this.location.locale === 'fr-ca' ? 'fr' : ''} `}
            >
                <div class="confirmation" flex-horizontal>
                    <div class="confirmation-message-icon">{icons.info2}</div>
                    <div class="confirmation-message">
                        {i18n('ad_blocker_detected')}
                    </div>
                </div>
                <button
                    onClick={() =>
                        this.hidePopup(AD_BLOCKER_POPUP_TAG_ELEMENT_ID)
                    }
                >
                    {i18n('got_it')}
                </button>
            </div>
        )
    }
}
